var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"max-width":"770px","margin-bottom":"5rem"}},[_c('the-header'),_c('search-bar'),_c('section-body')],1)}
var staticRenderFns = []

export { render, staticRenderFns }